import { useTranslation } from "react-i18next";
import type { S } from "@/shared/api/client";
import { today } from "@/shared/lib/format";
import { Badge, statusTone, type Tone } from "@/shared/ui/Badge";

export type Inv = S["InvoicingInvoice"];

type StatusOf = Pick<Inv, "status" | "payment_status" | "kind"> & { due_date?: string };

/**
 * What an invoice's status says and in which colour: a draft is grey (not real yet); an
 * issued invoice is blue while open, gold when partly paid, green when paid, and red once
 * it is past its due date unpaid. Credit and debit notes say what they are.
 */
export function invoiceState(inv: StatusOf, day: string): { label: string; tone: Tone } {
  if (inv.status === "issued" && inv.kind === "invoice") {
    const owed = inv.payment_status === "unpaid" || inv.payment_status === "partial";
    if (owed && inv.due_date && inv.due_date < day) return { label: "invoice.payStatuses.late", tone: "red" };
    return { label: `invoice.payStatuses.${inv.payment_status}`, tone: inv.payment_status === "unpaid" ? "blue" : statusTone(inv.payment_status) };
  }
  return { label: `invoice.statuses.${inv.status}`, tone: inv.status === "draft" ? "neutral" : statusTone(inv.status) };
}

export function InvoiceStatus({ inv }: { inv: StatusOf }) {
  const { t } = useTranslation();
  const s = invoiceState(inv, today());
  return <Badge tone={s.tone}>{t(s.label)}</Badge>;
}
